const imageBaseUrl = process.env.REACT_APP_IMAGE_URL;
const flg1 = imageBaseUrl + "immersion/middle-east.png";
const flg2 = imageBaseUrl + "immersion/malaysia.png";
const flg3 = imageBaseUrl + "immersion/thailand.png";
const flg5 = imageBaseUrl + "immersion/canadaflag.jpg";
const flg6 = imageBaseUrl + "immersion/FranceFlag.jpeg";
const flg7 = imageBaseUrl + "immersion/GermanyFlag.webp";
const img1 = imageBaseUrl + "immersion/citydubai1.jpg";
const img2 = imageBaseUrl + "immersion/Malaysiaaaa city.png";
const img3 = imageBaseUrl + "immersion/cities_in_thailand 1.png";
const img5 = imageBaseUrl + "immersion/trees-skyscrapers-distance.jpg";
const img6 = imageBaseUrl + "immersion/France.jpg";
const img7 = imageBaseUrl + "immersion/Germany.jpg";
const dubaiFile = imageBaseUrl + "immersion/Dubai.pdf";
const malaysiaFile = imageBaseUrl + "immersion/MALAYSIA.pdf.pdf_20250331_211827_0000.pdf";
const thailandBrochure = imageBaseUrl + "pdf/thailand_brochure.pdf";
const germanyBrochure = imageBaseUrl + "pdf/germany_brochure.pdf";
const franceBrochure = imageBaseUrl + "pdf/france_brochure.pdf";

const MiddleEastImmersionBenefit = {
    title: "Dubai",
    image: img1,
    flag: flg1,
    brochureUrl: dubaiFile,
    content: "The Dubai Immersion Program offers hands-on learning and real-world exposure to AI applications in Dubai. Participants engage with industry experts, attend sessions at the renowned RIT Dubai university, and visit leading companies to explore cutting-edge technologies. The program also includes cultural exploration, offering a chance to experience Dubai’s rich heritage and diverse traditions while gaining global insights into AI-driven solutions.",
};

const SouthEastAsiaImmersionBenefit = [
    {
        title: "Malaysia",
        image:img2 ,
        flag: flg2,
        brochureUrl: malaysiaFile,
        content: "This Malaysia Immersion Program is designed to offer students a holistic learning experience through a blend of academic sessions, industry exposure, and cultural exploration. The program provides a unique opportunity for students to gain practical insights, interact with professionals, and understand how cutting-edge technologies like AI and cybersecurity are impacting various industries and education sectors.",
    },
    {
        title: "Thailand",
        image:img3,
        flag: flg3,
        brochureUrl: thailandBrochure,
        content: "Asian Institute of Technology (AIT QS #51-100) is offering an education innovation camp which aims to inspire and ignite the young talented students through state-of-the-art interactive seminars and hands-on sessions in cutting-edge technologies focusing on AI technologies so that they would be innovative in finding the solutions to engineering, management, and social issues.",
    }
];

const EuropeImmersionBenefit = [
    {
        title: "France",
        image: img6,
        flag: flg6,
        brochureUrl: franceBrochure,
        content: <>The France Immersion Program offers hands-on learning and real world exposure to AI applications in France. Participants engage with industry experts, attend sessions at the renowned <strong> Aivancity School of Artificial Intelligence and Data Science</strong>, and visit leading companies to explore cutting-edge technologies. The program also includes cultural exploration, offering a chance to experience rich French heritage and diverse traditions while gaining global insights into AI-driven solutions</>,
    },
    {
        title: "Germany",
        image: img7,
        flag: flg7,
        brochureUrl: germanyBrochure,
        content: <>The Germany Immersion Program offers hands-on learning and real world exposure to AI 
        applications. Participants engage with industry experts, attend sessions at the renowned 
        <strong> Technical University Berlin</strong>, and visit leading companies to explore cutting-edge 
        technologies. The program also includes cultural exploration, offering a chance to 
        experience rich heritage and diverse traditions while gaining global insights into AI-driven
        solutions</>,
    },
];

const NorthAmericaImmersionBenefit = {
    title: "North America",
    image: img5,
    flag: flg5,
    content: "Engage with cutting-edge industries and leading institutions in North America. Gain valuable experience in a dynamic environment that fosters innovation and growth.",
};

export { 
    MiddleEastImmersionBenefit, 
    SouthEastAsiaImmersionBenefit, 
    EuropeImmersionBenefit, 
    NorthAmericaImmersionBenefit
};

